import React from "react";
import Image from "components/Elements/Image/Image.tsx";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { DOMAIN_NAME } from "utils/globalConsts.ts";
import { useContent } from "contexts/contentContext/contentContext.js";

const EmbedFormTemplateFooter = ({ linkFooters }) => {
  const { getLanguage } = useContent();
  const baseUrl = `https://${DOMAIN_NAME}/${getLanguage()}`;

  return (
    <div className="embed-dynamic-footer">
      {" "}
      <div className="left-side-footer">
        <LinkToNewTab fullUrl page={baseUrl + "/home"}>
          <Image
            className="jumbo-icon"
            name="jumbomail-logo-black"
            alt=""
            title=""
          />
        </LinkToNewTab>
      </div>
      <div className="right-side-footer">
        {linkFooters &&
          linkFooters.map((item, i) =>
            i === linkFooters.length - 1 ? (
              <div key={i} className="div-link">
                <a href={item.FooterLinkUrl} target="_blank" rel="noreferrer">
                  <span>{item.FooterLinkTitle}</span>
                </a>
              </div>
            ) : (
              <>
                <div key={i} className="div-link">
                  <a href={item.FooterLinkUrl} target="_blank" rel="noreferrer">
                    <span>{item.FooterLinkTitle}</span>
                  </a>
                </div>
                <div className="space">{" | "}</div>
              </>
            )
          )}
      </div>
    </div>
  );
};

export default EmbedFormTemplateFooter;
